/**
 * Agent Type — Include Endpoint List
 *
 * This allowlist drives where the HTTP layer injects an `agent_type`
 * query parameter.
 *
 * Keep this list scoped to explicit feature areas that require agent-type
 * filtering. URLs that do not match these fragments will not receive the
 * injected query param.
 *
 * Rules for entries:
 *   - Add only path fragments (no protocol, no leading slash).
 *   - Matching in `shouldIncludeAgentTypeInUrl()` (see `app/utils/agentType.ts`)
 *     is boundary-aware, so `api/v2/dealers` will NOT accidentally cover
 *     `api/v2/dealer-groups`.
 *
 * Lives under `src/types` so this config stays next to other shared type /
 * constant definitions and does not clutter `app/utils`.
 */
export const AGENT_TYPE_INCLUDED_PATHS: readonly string[] = [
  // Dealers APIs

  // Configure — calendar (ChannelSettings) & segments / message-focus (dealer-settings)
  'api/v2/dealer-settings',

  // Configure — template value preferences (MessageContentTab)
  'api/v2/message-content',
  'api/v2/dealer-value',
  'api/v2/dealer-special',
  'api/v2/footer-image',

  // Configure — static content (EmailsGridPage: templates, inventory, preferences)
  'api/v2/templates',
  'api/v2/dealer-inventory',
  'api/v2/preferences',

  // Configure + Test Nurturing — MIA (nurturing-journey stages, template generate)
  'api/v2/mia',

  // Test Nurturing page flows
  'api/v2/nurturing-automation',
  'api/v2/leads',

  // Human In The Loop (HIL) — templates + nurturing-automation (see above)
];
